export const ProvinceList = [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "NT",
    "NU",
    "ON",
    "PE",
    "QC",
    "SK",
    "YT",
]

export const enum FormType {
    FormOne,
    FormFour
}

export const PoolingAdministratorInfo = {
    administratorName: "CNA",
    address: "880 Taylor Creek Drive, Room 102",
    city: "Orleans",
    province: "ON",
    postalCode: "K4A 0Z9",
    phone: "613-702-0016",
    fax: "613-702-0017",
    email: "NPAC-CNA@cnac.ca"
}